import { api } from "./client";
import type { components } from "./types";

export type Calendar = components["schemas"]["Calendar"];
export type CalendarOverride = components["schemas"]["CalendarOverride"];

export interface ListOverridesParams {
  calendar_id?: number;
  date_from?: string;
  date_to?: string;
}

export function listCalendarOverrides(
  params: ListOverridesParams = {},
): Promise<CalendarOverride[]> {
  const qs = new URLSearchParams();
  if (params.calendar_id !== undefined) qs.set("calendar_id", String(params.calendar_id));
  if (params.date_from) qs.set("from", params.date_from);
  if (params.date_to) qs.set("to", params.date_to);
  const tail = qs.toString();
  return api.get<CalendarOverride[]>(`/calendar-overrides${tail ? `?${tail}` : ""}`);
}

export interface CreateOverrideBody {
  calendar_id: number;
  date_from: string;
  date_to: string;
  hours: number;
  reason?: string;
}

export function createCalendarOverride(body: CreateOverrideBody): Promise<CalendarOverride> {
  return api.post<CalendarOverride>("/calendar-overrides", body);
}

export interface UpdateOverrideBody {
  date_from?: string;
  date_to?: string;
  hours?: number;
  reason?: string;
  edit_reason?: string;
}

export function updateCalendarOverride(
  id: number,
  body: UpdateOverrideBody,
): Promise<CalendarOverride> {
  return api.patch<CalendarOverride>(`/calendar-overrides/${id}`, body);
}

export function deleteCalendarOverride(id: number, editReason = ""): Promise<void> {
  const qs = editReason ? `?edit_reason=${encodeURIComponent(editReason)}` : "";
  return api.delete<void>(`/calendar-overrides/${id}${qs}`);
}
